import type { Meta, Story } from '@tntd/storybook-react-storykit'
import React from 'react'
import styled from 'styled-components'

import { Empty } from './empty'

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
`

export default {
  component: Empty,
  title: 'Empty',
} as Meta

export const Primary: Story<{}> = (args) => <Container></Container>

Primary.args = {}
